import {connect} from 'react-redux';
import React, {Component} from 'react';
import ReactPaginate from 'react-paginate';

import ObjectPreview from '../Base/PropertyPreview';
import * as SearchConst from '../../constants/Search';
import {findObjects, setPage} from '../../actions/Search';

const defaultProps = {
    setPage: page => {
    },
    findObjects: requestParams => {
    }
};

class ResultSearchContent extends Component {
    handlePageClick = data => {
        const page = data.selected + 1;

        this.props.setPage(page);
        this.findObjectsAfterChangeRequestParam(SearchConst.REQUEST_PARAMS_NAMES.PAGE, page);
    };

    findObjectsAfterChangeRequestParam = (name, value) => {
        const {requestParams} = this.props;
        const newRequestParams = Object.assign({}, requestParams);

        newRequestParams[name] = value;

        this.props.findObjects(newRequestParams);
    };

    getSearchLink = () => {
        const {dateStart, dateEnd} = this.props;
        let response = '?';

        if (dateStart !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_START}=${dateStart}&`;
        }
        if (dateEnd !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_END}=${dateEnd}`;
        }
        return response;
    };

    render() {
        const {
            searchResult,
            requestParams,
            searchPage: {
                requestParams: {
                    page
                }
            }
        } = this.props;
        const pageCount = Math.ceil(searchResult.paging.totalCount / requestParams.pageSize);

        return (
            <div className="rezult_serch_content">
                {searchResult.rows.map(object =>
                    <ObjectPreview key={object.id} object={object} searchLink={this.getSearchLink()} />
                )}

                <div className="center">
                    <div className="link_page lp_bottom">
                        <ReactPaginate
                            nextLabel={'.'}
                            previousLabel={'.'}
                            forcePage={page - 1}
                            pageCount={pageCount}
                            pageClassName={'page'}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            nextClassName={'next_page'}
                            previousClassName={'prev_page'}
                            activeClassName={'active_link_page'}
                            onPageChange={::this.handlePageClick}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ResultSearchContent.defaultProps = defaultProps;

const mapStateToProps = state => ({
    searchPage: state.searchPage,
    searchResult: state.searchPage.searchResult,
    requestParams: state.searchPage.requestParams,
    dateEnd: state.searchPage.requestParams.dateEnd,
    dateStart: state.searchPage.requestParams.dateStart
});

const mapDispatchToProps = {
    setPage,
    findObjects
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultSearchContent);


// WEBPACK FOOTER //
// ./src/components/Search/ResultSearchContent.js